import { SideNavInterface } from '@app/@layout/backend/side-nav.type';
import { PermissionKey as PK } from '@app/@shared/@types/permission';
import { environment } from '@env/environment';

export const MENU: SideNavInterface[] | any = [
  {
    path: 'dashboard',
    title: 'menu.dashboard',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'home',
    submenu: [],
  },
  {
    path: 'case-management',
    title: 'menu.caseManagement',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'audit',
    permissions: [PK.VIEW_PATIENTS, PK.MANAGE_PATIENTS],
    submenu: [
      {
        path: 'case-management/patients',
        title: 'menu.patientList',
        iconType: '',
        iconTheme: '',
        permissions: [PK.VIEW_PATIENTS],
        submenu: [],
      },
      {
        path: 'case-management/profile',
        title: 'menu.createPatient',
        iconType: '',
        iconTheme: '',
        permissions: [PK.MANAGE_PATIENTS],
        submenu: [],
      },
      {
        path: 'case-management/caregiver-list',
        title: 'menu.caregiverList',
        iconType: '',
        iconTheme: '',
        permissions: [PK.VIEW_PATIENTS],
        submenu: [],
      },
    ],
  },
  {
    path: 'assessments',
    title: 'menu.assessments',
    permissions: [PK.VIEW_ASSESSMENTS, PK.MANAGE_ASSESSMENTS],
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'edit',
    submenu: [
      {
        path: 'assessments/plan-assessments',
        title: 'menu.planAssessment',
        permissions: [PK.MANAGE_ASSESSMENTS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'assessments',
        title: 'menu.plannedAssessments',
        permissions: [PK.VIEW_ASSESSMENTS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
    ],
  },
  {
    path: 'questionnaire-management',
    title: 'menu.questionnaires',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file',
    permissions: [PK.VIEW_QUESTIONNAIRES, PK.MANAGE_QUESTIONNAIRES],
    submenu: [
      {
        path: 'questionnaire-management/questionnaire-list',
        title: 'menu.questionnairesList',
        permissions: [PK.VIEW_QUESTIONNAIRES],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'questionnaire-management/questionnaire-form',
        title: 'menu.uploadQuestionnaire',
        permissions: [PK.MANAGE_QUESTIONNAIRES],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'questionnaire-management/questionnaire-version-list',
        title: 'menu.questionnairesVersionList',
        permissions: [PK.VIEW_QUESTIONNAIRES],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'questionnaire-management/questionnaire-bundles-list',
        title: 'menu.questionnaireBundles',
        permissions: [PK.MANAGE_QUESTIONNAIRES],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
    ],
  },
  {
    path: 'user-management',
    title: 'menu.userManagement',
    permissions: [PK.VIEW_USERS, PK.MANAGE_USERS],
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: 'user-management/users',
        title: 'menu.listUsers',
        permissions: [PK.VIEW_USERS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'user-management/user-form',
        title: 'menu.newUser',
        permissions: [PK.MANAGE_USERS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
    ],
  },
  {
    path: 'administration',
    title: 'menu.administration',
    permissions: [PK.VIEW_ROLES_PERMISSIONS, PK.VIEW_SETTINGS, PK.VIEW_SYSCONF],
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'setting',
    submenu: [
      {
        path: 'administration/reports',
        title: 'menu.reports',
        permissions: [PK.VIEW_REPORTS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'administration/permission-matrix',
        title: 'menu.permissionMatrix',
        permissions: [PK.VIEW_ROLES_PERMISSIONS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'administration/permissions',
        title: 'menu.permissions',
        permissions: [PK.VIEW_ROLES_PERMISSIONS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'administration/roles',
        title: 'menu.roles',
        permissions: [PK.VIEW_ROLES_PERMISSIONS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      {
        path: 'administration/departments',
        title: 'menu.departments',
        permissions: [PK.VIEW_SETTINGS],
        iconType: '',
        iconTheme: '',
        icon: '',
        submenu: [],
      },
      {
        path: 'administration/disclaimers',
        title: 'menu.disclaimers',
        permissions: [PK.VIEW_SETTINGS],
        iconType: '',
        iconTheme: '',
        icon: '',
        submenu: [],
      },
      {
        path: 'administration/assessments',
        title: 'menu.assessments',
        permissions: [PK.VIEW_SETTINGS],
        iconType: '',
        iconTheme: '',
        icon: '',
        submenu: [],
      },
      {
        path: 'administration/patient-statuses',
        title: 'menu.patientStatuses',
        permissions: [PK.VIEW_SETTINGS],
        iconType: '',
        iconTheme: '',
        submenu: [],
      },
      // {
      //   path: 'administration/email-templates',
      //   title: 'menu.emailTemplates',
      //   permissions: [PK.VIEW_SETTINGS],
      //   iconType: 'nzIcon',
      //   iconTheme: 'outline',
      //   icon: 'code',
      //   submenu: [],
      // },
      {
        path: 'administration/version',
        title: 'menu.version',
        permissions: [PK.VIEW_SETTINGS],
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'code',
        submenu: [],
      },
      // {
      //   path: 'administration/settings',
      //   title: 'menu.settings',
      //   permissions: [PK.VIEW_SETTINGS, PK.VIEW_SYSCONF],
      //   iconType: '',
      //   iconTheme: '',
      //   submenu: [
      //     {
      //       path: 'administration/settings/system-configuration',
      //       title: 'menu.systemConfiguration',
      //       permissions: [PK.VIEW_SYSCONF],
      //       iconType: '',
      //       iconTheme: '',
      //       submenu: [],
      //     },
      //     {
      //       path: 'administration/settings/patient-statuses',
      //       title: 'menu.patientStatuses',
      //       permissions: [PK.VIEW_SETTINGS],
      //       iconType: '',
      //       iconTheme: '',
      //       submenu: [],
      //     },
      //   ],
      // },
    ],
  },
];

// Logic for conditionally adding email templates
// button on the menu, if env variable is true..

if (environment.email) {
  MENU[5].submenu.splice(8, 0, {
    path: 'administration/email-templates',
    title: 'menu.emailTemplates',
    permissions: [PK.VIEW_SETTINGS],
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'code',
    submenu: [],
  });
}
